class Product {

	init() {
		this.Productswiper();
	}

	Productswiper() {
		// pickupスライダー
	const swiper = new Swiper('.swiper', {
		// Optional parameters
		loop: true,

		effect:'slide',
		slidesPerView:2,
		centeredSlides: true,
		spaceBetween: 8,

		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
		speed: 3000,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
		},
	
		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	
		// And if we need scrollbar
		scrollbar: {
			el: '.swiper-scrollbar',
		},
  
    // スライドの表示枚数：768px以上の場合
    768: {
      spaceBetween: 30
    },
	});
	}

}

export default Product;
